'use strict';

import * as types from './types';
import qs from 'qs';

export const loginSuccess = user => ({
	type: types.LOGIN_SUCCESS,
	data: {
		user,
	}
});

export const setLoggedInUser = user => ({
	type: types.SET_LOGGED_IN_USER,
	data: {
		user,
	},
});

export const fetchUser = username => ({
	type: types.FETCH_USER,
	meta: {
		async: true,
		endPoint: `/user/${ username }/getUser`,
		method: 'GET'
	}
});

export const getUsers = ({ page, pageSize, sort, filters }) => {

	const q = qs.stringify({ page, pageSize, sort, filters });

	return {
		type: types.GET_USERS,
		meta: {
			async: true,
			endPoint: `/users/find?${ q }`,
			method: 'GET',
		},
	};
};

export const searchUsers = q => ({
	type: types.SEARCH_USERS,
	meta: {
		async: true,
		endPoint: `/usersSearch?q=${ q }`,
		method: 'GET',
	},
});

export const postSettings = (username, settings, byPassLoading) => ({
	type: types.POST_SETTINGS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/postSettings`,
		method: 'POST',
		body: {
			settings,
		},
		byPassLoading,
	},
});

export const changePassphrase = (username, { currentPassphrase, newPassphrase }) => ({
	type: types.CHANGE_PASSPHRASE,
	meta: {
		async: true,
		endPoint: `/user/${ username }/changePassphrase`,
		method: 'POST',
		body: {
			currentPassphrase,
			newPassphrase,
		},
	},
});

export const postCreateUser = ({
	firstName,
	lastName,
	username,
	email,
	passphrase,
	office,
	roles,
	workWeek,
}) => ({
	type: types.POST_CREATE_USER,
	meta: {
		async: true,
		endPoint: `/user/createUser`,
		method: 'POST',
		body: {
			firstName,
			lastName,
			username,
			email,
			passphrase,
			office,
			roles,
			workWeek,
		},
	},
});

export const postUpdateUser = (
	_id,
	{
		firstName,
		lastName,
		username,
		email,
		passphrase,
		office,
		roles,
		workWeek,
	}
) => ({
	type: types.POST_UPDATE_USER,
	meta: {
		async: true,
		endPoint: `/user/updateUser`,
		method: 'POST',
		body: {
			userId: _id,
			updates: {
				firstName,
				lastName,
				username,
				email,
				passphrase,
				office,
				roles,
				workWeek,
			},
		},
	},
});

export const deleteUser = userId => ({
	type: types.DELETE_USER,
	meta: {
		async: true,
		endPoint: `/user/deleteUser`,
		method: 'POST',
		body: {
			userId,
		},
	},
});
